// extracted by mini-css-extract-plugin
export default {"heading":"rj-z","list":"sj-z"};